
import { types as sdkTypes } from '../../util/sdkLoader';
import { getCMSPage, updateCMSPage } from '../../util/api';
import { denormalizeAssetData } from '../../util/data';
import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const FETCH_PAGE_REQUEST = 'app/ListingPage/FETCH_PAGE_REQUEST';
export const FETCH_PAGE_SUCCESS = 'app/ListingPage/FETCH_PAGE_SUCCESS';
export const FETCH_PAGE_ERROR = 'app/ListingPage/FETCH_PAGE_ERROR';

export const FETCH_PAGE_TRANSLATIONS_REQUEST = 'app/ListingPage/FETCH_PAGE_TRANSLATIONS_REQUEST';
export const FETCH_PAGE_TRANSLATIONS_SUCCESS = 'app/ListingPage/FETCH_PAGE_TRANSLATIONS_SUCCESS';
export const FETCH_PAGE_TRANSLATIONS_ERROR = 'app/ListingPage/FETCH_PAGE_TRANSLATIONS_ERROR';

export const UPDATE_PAGE_TRANSLATIONS_REQUEST = 'app/ListingPage/UPDATE_PAGE_TRANSLATIONS_REQUEST';
export const UPDATE_PAGE_TRANSLATIONS_SUCCESS = 'app/ListingPage/UPDATE_PAGE_TRANSLATIONS_SUCCESS';
export const UPDATE_PAGE_TRANSLATIONS_ERROR = 'app/ListingPage/UPDATE_PAGE_TRANSLATIONS_ERROR';

// ================ Reducer ================ //

const initialState = {
  page: null,
  fetchPageInProgress: false,
  fetchPageError: null,

  pageTranslations: null,
  fetchPageTranslationsInProgress: false,
  fetchPageTranslationsError: null,


  updatePageTranslationsSuccess: false,
  updatePageTranslationsInProgress: false,
  updatePageTranslationsError: null,
};

const editTranslationsPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {

    case FETCH_PAGE_REQUEST:
      return { ...state, fetchPageInProgress: true, fetchPageError: null };
    case FETCH_PAGE_SUCCESS:
      return { ...state, fetchPageInProgress: false, page: payload };
    case FETCH_PAGE_ERROR:
      return { ...state, fetchPageInProgress: false, fetchPageError: payload };

    case FETCH_PAGE_TRANSLATIONS_REQUEST:
      return { ...state, fetchPageTranslationsInProgress: true, fetchPageTranslationsError: null };
    case FETCH_PAGE_TRANSLATIONS_SUCCESS:
      return { ...state, fetchPageTranslationsInProgress: false, pageTranslations: payload };
    case FETCH_PAGE_TRANSLATIONS_ERROR:
      return { ...state, fetchPageTranslationsInProgress: false, fetchPageTranslationsError: payload };

    case UPDATE_PAGE_TRANSLATIONS_REQUEST:
      return { ...state, updatePageTranslationsInProgress: true, updatePageTranslationsError: null };
    case UPDATE_PAGE_TRANSLATIONS_SUCCESS:
      return { ...state, updatePageTranslationsInProgress: false, updatePageTranslationsSuccess: payload };
    case UPDATE_PAGE_TRANSLATIONS_ERROR:
      return { ...state, updatePageTranslationsInProgress: false, updatePageTranslationsError: payload };

    default:
      return state;
  }
};

export default editTranslationsPageReducer;

// ================ Action creators ================ //

export const fetchPageRequest = () => ({ type: FETCH_PAGE_REQUEST });
export const fetchPageSuccess = payload => ({
  type: FETCH_PAGE_SUCCESS,
  payload,
});
export const fetchPageError = error => ({
  type: FETCH_PAGE_ERROR,
  error: true,
  payload: error,
});

export const fetchPageTranslationsRequest = () => ({ type: FETCH_PAGE_TRANSLATIONS_REQUEST });
export const fetchPageTranslationsSuccess = payload => ({
  type: FETCH_PAGE_TRANSLATIONS_SUCCESS,
  payload,
});
export const fetchPageTranslationsError = error => ({
  type: FETCH_PAGE_TRANSLATIONS_ERROR,
  error: true,
  payload: error,
});

export const updatePageTranslationsRequest = () => ({ type: UPDATE_PAGE_TRANSLATIONS_REQUEST });
export const updatePageTranslationsSuccess = payload => ({
  type: UPDATE_PAGE_TRANSLATIONS_SUCCESS,
  payload,
});
export const updatePageTranslationsError = error => ({
  type: UPDATE_PAGE_TRANSLATIONS_ERROR,
  error: true,
  payload: error,
});


// ================ Thunks ================ //


export const fetchPage = (pageAsset) => (dispatch, getState, sdk) => {
  dispatch(fetchPageRequest());

  return sdk.assetByAlias(pageAsset)
    .then(res => {
      const page = denormalizeAssetData(res.data);

      dispatch(fetchPageSuccess(page));
      return res
    })
    .catch(e => {
      dispatch(fetchPageError(storableError(e)));
    });
};

export const fetchPageTranslations = (pageId) => (dispatch, getState, sdk) => {
  dispatch(fetchPageTranslationsRequest());

  return getCMSPage(pageId)
    .then(res => {
      dispatch(fetchPageTranslationsSuccess(res));
      return res
    })
    .catch(e => {
      dispatch(fetchPageTranslationsError(storableError(e)));
    });
};

export const updatePageTranslations = (pageId, content, userId) => (dispatch, getState, sdk) => {
  dispatch(updatePageTranslationsRequest());

  return updateCMSPage({ pageId, content, userId })
    .then(res => {
      dispatch(updatePageTranslationsSuccess(true));
      // set updated initial values
      dispatch(fetchPageTranslationsSuccess(res?.content));

      setTimeout(() => {
        dispatch(updatePageTranslationsSuccess(false));
      }, 2000)
      return res
    })
    .catch(e => {
      dispatch(updatePageTranslationsError(storableError(e)));
    });
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {

  const pageId = params?.pageId;
  const pageAsset = { path: `content/pages/${pageId}.json`, alias: 'latest' };

  const promises = [
    dispatch(fetchPage(pageAsset)),
    dispatch(fetchPageTranslations(pageId)),
  ]

  return Promise.all(promises);
};
